function fn_scrollreveal() {
    if ($(window).width() > 1024 && !$("html.sr").length && $("[data-reveal-fade]").length || $("[data-reveal-fade-slow]").length) {
        window.sr = ScrollReveal({ duration: 2000 });
        if (sr.isSupported()) {
            document.documentElement.classList.add('sr');
            sr.reveal('[data-reveal-fade]', {
                duration: 500,
                easing: 'ease-in',
                scale: 1,
                distance: 0,
                delay: 300,
                viewFactor : 0.15,
                reset: false,
                beforeReveal: function (domEl) {
                    $(domEl).attr("data-reveal-fade","revealed");
                }
            }, 0);
            sr.reveal('[data-reveal-fade="slow"]', {
                duration: 500,
                easing: 'ease-in',
                scale: 1,
                distance: 0,
                delay: 150,
                viewFactor : 0.25,
                reset: false,
                beforeReveal: function (domEl) {
                    $(domEl).attr("data-reveal-fade","revealed");
                }
            }, 150);
        }
    }
}